// extracted by mini-css-extract-plugin
export default {"TelegramChat":"telegram-chat_TelegramChat__QOtjE","subscriptionRow":"telegram-chat_subscriptionRow__tybh9"};